import Attribute, { Props as AttributeProps } from './_Attribute';
import Product from '@models/product';

export interface Props {
  sectionTitle: string;
  attributes?: Array<AttributeProps>;
  selectedSkus: Array<string>;
  products: Array<Product>;
  asContentRow?: boolean;
}

const Section = ({ sectionTitle, attributes, selectedSkus, products, asContentRow }: Props) => (
  <div className="tw-bg-white">
    {sectionTitle && (
      <div className="tw-w-full tw-grid">
        <div className="tw-bg-surface-100 tw-py-3 tw-w-full">
          <h5 className="tra-text-web-heading-6 tw-sticky tw-left-0 tw-pl-6 tw-inline-block">
            {sectionTitle}
          </h5>
        </div>
        {attributes?.map(({ attribute, shortDescription, salesforceField }, idx) => (
          <Attribute
            key={idx}
            attribute={attribute}
            shortDescription={shortDescription}
            salesforceField={salesforceField}
            selectedSkus={selectedSkus}
            products={products}
            asContentRow={asContentRow}
          />
        ))}
      </div>
    )}
  </div>
);

export default Section;
